import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { inject, observer } from "mobx-react";

import DialogBox from "../src/common/components/dialog/dialog";
import Loader from "./common/components/loader/loader-component";
import Login from "./components/login/component/login-container";
import ProtectedRoute from "./common/components/protected-route/protected-route";
import ReferenceData from "../src/components/referencedata/components/reference-data-component";
import Toolbar from "./common/components/toolbar/component/toolbar";
import WelcomeScreen from "./components/WelcomeScreen";
import NGLTeamDailyReport from "./components/nglteamdailyreport/component/ngl-team-daily-report-component";
import NGLTowerConstraints from './components/ngltowerconstraints/component/ngl-towerConstraints';
import OutageScheduleReport from "./components/OutageScheduleReport/component/outage-schedule-report-component";
import GeneratorVendorTeamplateScreen from "./components/generatorvendortemplatescreen/component/generator-vendor-template-screen";
import ReferenceReport from "./components/referencereport/components/reference-report-component";
import OutageUserManagement from "./components/OutageScheduleReport/component/outage-schedule-user-management";
import MarketingRepManagement from "./components/soxauditscreen/component/marketing-rep-management";
import LeaseMasterPriceChangeComponent from "./components/soxauditscreen/component/lease-master-price-change-component";
import TransactionScreen from "./components/gainlossscreen/component/gainloss-transaction-screen";
import GainLossReferenceScreen from "./components/gainlossscreen/component/gainloss-reference-screen";
import GainLossListsScreen from "./components/gainlossscreen/component/listsscreen/gainloss-lists-screen";
import GainLossUnitpriceScreen from "./components/gainlossscreen/component/gainloss-unitprice-screen";
import GainLossSystemVarianceScreen from "./components/gainlossscreen/component/gainloss-system-variance-screen";
import GainLossSubSystemVarianceScreen from "./components/gainlossscreen/component/gain-loss-subSystemVariance-screen";
import ReleaseIncidentScreen from "./components/releaseincident/component/release-incident-screen";
import SystempipelineListsScreen from "./components/systempipeline/component/listsscreen/systempipeline-lists-screen";
import SystemListsScreen from "./components/systempipeline/component/listsscreen/system-lists-screen";
import NominationCriteria from './components/nomination/component/nomination-criteria-component';
import PLMAlarmWeekly from "./components/plm-alarm/component/plm-alarm-weekly";
import NGLSpotPriceAndTowerTargets from './components/ngl-spot-price-and-tower-targets/component/spot-price-and-tower-targets';

@inject("AuthStore", "CommonStore")
@observer
class Home extends Component {
    constructor(props) {
        super(props);
        this.props.CommonStore.childComponent = this.setChildComponentValue();
        this.state = {
            height: "768px",
            width: "",
            showLoader: true,
        };
    }

    setChildComponentValue = () => {
        const navigation = this.props.location.pathname;
        switch (navigation) {
            case "/reference/screens":
                return "ReferenceData";
            case "/":
                return "";
            default:
                return "";
        }
    };

    reportHandler = (child, navigation) => {
        const { CommonStore, history } = this.props;
        CommonStore.childComponent = child;
        CommonStore.referenceNavigation = navigation;
        history.push(navigation);
    };

    getCustomScreen = (screenName) => {
        switch (screenName) {
            case "NGLTeamDailyReport":
                return NGLTeamDailyReport;
            case "NGLTowerConstraints":
                return NGLTowerConstraints;
            case "NGLSpotPrice":
                return NGLSpotPriceAndTowerTargets;
            case "NGLTowerTargets":
                return NGLSpotPriceAndTowerTargets;
            case "OutageSchedule":
                return OutageScheduleReport;
            case "UnplannedOutageSchedule":
                return OutageScheduleReport;
            case "BorderFlow":
                return NominationCriteria;
            case "E6Frac":
                return NominationCriteria;
            case "GeneratorVendorTemplate":
                return GeneratorVendorTeamplateScreen;
            case "OutageUserManagement":
                return OutageUserManagement;
            case "SOXMarketingRep":
                return MarketingRepManagement;
            case "SOXLeasePricing":
                return LeaseMasterPriceChangeComponent;
            case "GainLossTransactionScreen":
                return TransactionScreen;
            case "GainLossListsScreen":
                return GainLossListsScreen;
            case "SystempipelineListsScreen":
                return SystempipelineListsScreen;
            case "SystemListsScreen":
                return SystemListsScreen;
            case "GainLossReferenceScreen":
                return GainLossReferenceScreen;
            case "GainLossUnitpriceScreen":
                return GainLossUnitpriceScreen;
            case "GainLossSystemVarianceScreen":
                return GainLossSystemVarianceScreen;
            case "SOXContractPricing":
                return LeaseMasterPriceChangeComponent;
            case "GainLossSubSystemVarianceScreen":
                return GainLossSubSystemVarianceScreen;
            case "ReleaseIncidentScreen":
                return ReleaseIncidentScreen;
            case "PLMWeeklyReport":
                return PLMAlarmWeekly;
            default:
                return "";
        }
    };

    async componentWillMount() {
        this.setState({
            height: window.innerHeight - window.innerHeight * 0.17,
            width: window.innerWidth,
        });
    }

    render() {
        const { showLoader, screenDetails, reportDetails } = this.props.CommonStore;
        const { isLoggedIn } = this.props.AuthStore;
        return (
            <div
                id="App"
                className={isLoggedIn ? "align-middle .app-body-container" : ""}
                style={isLoggedIn ? { height: "100%" } : null}
            >
                <DialogBox />
                {showLoader ? <Loader /> : null}
                {isLoggedIn ? (
                    <>
                        <Toolbar
                            reportHandler={this.reportHandler}
                            {...this.state}
                            {...this.props}
                        />
                        <div>
                            <Switch>
                                <ProtectedRoute
                                    key={"test"}
                                    path="/OutageSchedule/:profile"
                                    component={OutageScheduleReport}
                                    {...this.state}
                                    {...this.props}
                                />
                                <ProtectedRoute
                                    key={"test"}
                                    path="/UnplannedOutageSchedule/:profile"
                                    component={OutageScheduleReport}
                                    {...this.state}
                                    {...this.props}
                                />
                                <ProtectedRoute
                                    key={"test"}
                                    path="/SOXLeasePricing"
                                    component={LeaseMasterPriceChangeComponent}
                                    {...this.state}
                                    {...this.props}
                                />
                                <ProtectedRoute
                                    key={"test"}
                                    path="/SOXContractPricing"
                                    component={LeaseMasterPriceChangeComponent}
                                    {...this.state}
                                    {...this.props}
                                />
                                <ProtectedRoute
                                    key={"test"}
                                    path="/SOXMarketingRep"
                                    component={MarketingRepManagement}
                                    {...this.state}
                                    {...this.props}
                                />
                                <ProtectedRoute
                                    key={"test"}
                                    path="/ContractPriceAuditReport"
                                    component={ReferenceReport}
                                    {...this.state}
                                    {...this.props}
                                />

                                <ProtectedRoute
                                    key={"test"}
                                    path="/LeasePriceAuditReport"
                                    component={ReferenceReport}
                                    {...this.state}
                                    {...this.props}
                                />

                                <ProtectedRoute
                                    key={"test"}
                                    path="/ReleaseIncidentScreen/:event_id"
                                    component={ReleaseIncidentScreen}
                                    {...this.state}
                                    {...this.props}
                                />
                                <Route path="/login" render={(props) => <Login {...props} />} />
                                {screenDetails &&
                                    screenDetails
                                        .filter((screenDetail) => screenDetail.screen.active)
                                        .map((screenDetail) => (
                                            <ProtectedRoute
                                                key={screenDetail.screen.rowKey}
                                                path={`/reference/${screenDetail.screen.name}`}
                                                component={
                                                    screenDetail.screen.isCustomScreen
                                                        ? this.getCustomScreen(screenDetail.screen.name)
                                                        : ReferenceData
                                                }
                                                {...this.state}
                                                {...this.props}
                                            />
                                        ))}
                                {reportDetails &&
                                    reportDetails
                                        .filter((screenDetail) => screenDetail.screen.active)
                                        .map((screenDetail) => (
                                            <ProtectedRoute
                                                key={screenDetail.screen.rowKey}
                                                path={`/reference/${screenDetail.screen.name}`}
                                                component={ReferenceReport}
                                                {...this.state}
                                                {...this.props}
                                            />
                                        ))}
                                <ProtectedRoute
                                    path="/"
                                    exact
                                    component={WelcomeScreen}
                                    {...this.state}
                                    {...this.props}
                                />
                            </Switch>
                        </div>
                    </>) : <Login {...this.props} />
                }
            </div>
        );
    }
}

export default Home;